module.exports = __webpack_public_path__ + "121198423c0eb235f03d36b5562e49ae.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-24.png
// module id = 2072
// module chunks = 0